import { create } from 'zustand/react'

import { RegisterForm } from '../../../modules/auth/register-page/register.interface'

interface RegisterStore {
  step: number
  registerData: RegisterForm | null
  setStep: (step: number) => void
  setRegisterData: (data: RegisterForm) => void
}

export const useRegisterStore = create<RegisterStore>(
  (set): RegisterStore => ({
    step: 1,
    registerData: null,
    setStep: (step: any) => set({ step }),
    setRegisterData: (data: RegisterForm) => set({ registerData: data }),
  }),
)
